import React, { useEffect } from 'react';
import CNPJMaskInput from '../masks/CNPJMaskInput';
import TelefoneMaskInput from '../masks/TelefoneMaskInput';
import CelularMaskInput from '../masks/CelularMaskInput';
import CEPMaskInput from '../masks/CEPMaskInput';

function EscolaModal({ show, onClose, onSubmit, form = {}, handleChange, ufs = [], cidades = [], title = 'CADASTRO DE ESCOLA', onBuscarCnpj, isBuscandoCnpj = false }) {
  useEffect(() => {
    if (!show) return;
    if (form.logrCidade && cidades.length > 0) {
      const norm = s => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const match = cidades.find(c => norm(c.nome) === norm(form.logrCidade));
      if (match && match.nome !== form.logrCidade) {
        handleChange({ target: { name: 'logrCidade', value: match.nome } });
      }
    }
  }, [show, form.logrCidade, cidades]);

  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-building me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form id="escola-form" onSubmit={onSubmit}>
              <div className="row g-3">
                <div className="col-12 col-sm-3 col-md-3 input-group-sm">
                  <label className="form-label-sm">CNPJ</label>
                  <div className="input-group input-group-sm">
                      <CNPJMaskInput
                        value={form.cnpj || ''}
                        onChange={e => handleChange({ target: { name: 'cnpj', value: e.target.value } })}
                        name="cnpj"
                        type="text"
                        required
                      />
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onBuscarCnpj} disabled={isBuscandoCnpj} title="Buscar dados na Receita Federal">
                      {isBuscandoCnpj ? <span className="spinner-border spinner-border-sm" role="status" /> : <i className="bi bi-search" />}
                    </button>
                  </div>
                </div>
                <div className="col-12 col-sm-2 col-md-2 input-group-sm">
                  <label className="form-label-sm">INEP</label>
                  <input onChange={handleChange} value={form.inep || ''} name="inep" type="text" className="form-control" required />
                </div>
                <div className="col-12 col-sm-7 col-md-7 input-group-sm">
                  <label className="form-label-sm">Nome</label>
                  <input onChange={handleChange} value={form.nome || ''} name="nome" type="text" className="form-control" required />
                </div>
                <div className="col-12 col-sm-12 col-md-12 input-group-sm">
                  <label className="form-label-sm">Conselho</label>
                  <input onChange={handleChange} value={form.conselho || ''} name="conselho" type="text" className="form-control" />
                </div>
                <div className="col-md-6 input-group-sm">
                  <label className="form-label-sm">Email</label>
                  <input onChange={handleChange} value={form.email || ''} name="email" type="text" className="form-control" />
                </div>
                <div className="col-md-3 input-group-sm">
                  <label className="form-label-sm">Telefone</label>
                  <TelefoneMaskInput value={form.telefone || ''} onChange={e => handleChange({ target: { name: 'telefone', value: e.target.value } })} name="telefone" type="text" />
                </div>
                <div className="col-md-3 input-group-sm">
                  <label className="form-label-sm">Celular</label>
                  <CelularMaskInput value={form.celular || ''} onChange={e => handleChange({ target: { name: 'celular', value: e.target.value } })} name="celular" type="text" />
                </div>
                <div className="col-md-6 input-group-sm">
                  <label className="form-label-sm">Endereço</label>
                  <input onChange={handleChange} value={form.endereco || form.logrNome || ''} name="endereco" type="text" className="form-control" />
                </div>
                <div className="col-md-2 input-group-sm">
                  <label className="form-label-sm">Número</label>
                  <input onChange={handleChange} value={form.logrNum || ''} name="logrNum" type="text" className="form-control" />
                </div>
                <div className="col-md-4 input-group-sm">
                  <label className="form-label-sm">Complemento</label>
                  <input onChange={handleChange} value={form.logrCompl || ''} name="logrCompl" type="text" className="form-control" />
                </div>
                <div className="col-md-4 input-group-sm">
                  <label className="form-label-sm">Bairro</label>
                  <input onChange={handleChange} value={form.logrBairro || ''} name="logrBairro" type="text" className="form-control" />
                </div>
                <div className="col-md-3 input-group-sm">
                  <label className="form-label-sm">CEP</label>
                  <CEPMaskInput value={form.logrCep || ''} onChange={e => handleChange({ target: { name: 'logrCep', value: e.target.value } })} name="logrCep" type="text" />
                </div>
                <div className="col-md-2 input-group-sm">
                  <label className="form-label-sm">UF</label>
                  <select className="form-select" value={form.logrUf || ''} onChange={handleChange} name="logrUf">
                    <option value="">Selecione uma UF...</option>
                    {ufs.map((uf, index) => (<option key={index} value={uf.sigla}>{uf.sigla}</option>))}
                  </select>
                </div>
                <div className="col-md-3 input-group-sm">
                  <label className="form-label-sm">Cidade</label>
                  <select className="form-select" value={cidades.find(c => c.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '') === (form.logrCidade || '').normalize('NFD').replace(/[\u0300-\u036f]/g, ''))?.nome || form.logrCidade || ''} onChange={handleChange} name="logrCidade">
                    <option value="">Selecione uma cidade...</option>
                    {cidades.map((cidade, index) => (<option key={index} value={cidade.nome}>{cidade.nome}</option>))}
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer" style={{ padding: '0.35rem 1rem' }}>
            <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancelar</button>
            <button type="submit" form="escola-form" className="btn btn-success btn-sm">Salvar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EscolaModal;
